export default __webpack_public_path__ + "static/speaker5-d0b57d8926734386dd01513b6430f222.jpg";